"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActionFactory = (function () {
    function ActionFactory() {
    }
    ActionFactory.prototype.creator = function (type) {
        return function (payload) { return ({ type: type, payload: payload }); };
    };
    return ActionFactory;
}());
exports.ActionFactory = ActionFactory;
//# sourceMappingURL=action-factory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngfk/ts-redux/dist/action-factory.js
// module id = 101
// module chunks = 0